import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom';
import Support from './components/Support';
import PrivacyPolicy from './components/PrivacyPolicy';
import './App.css';

const Header: React.FC = () => {
  const location = useLocation();
  const currentPage = location.pathname === '/support' ? 'Support' : 'Privacy Policy';
  
  return (
    <header className="bg-white shadow-sm border-b">
      <div className="max-w-4xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-gradient-to-r from-blue-500 to-purple-600 rounded-lg flex items-center justify-center">
              <span className="text-white font-bold text-lg">BN</span>
            </div>
            <h1 className="text-2xl font-bold text-gray-900">BuyNothings</h1>
          </div>
          <div className="flex items-center space-x-6">
            <nav className="flex space-x-4">
              <Link 
                to="/" 
                className={`px-3 py-2 rounded-md text-sm font-medium transition-colors ${
                  location.pathname === '/' 
                    ? 'bg-blue-100 text-blue-700' 
                    : 'text-gray-600 hover:text-gray-900'
                }`}
              >
                Privacy Policy
              </Link>
              <Link 
                to="/support" 
                className={`px-3 py-2 rounded-md text-sm font-medium transition-colors ${
                  location.pathname === '/support' 
                    ? 'bg-blue-100 text-blue-700' 
                    : 'text-gray-600 hover:text-gray-900'
                }`}
              >
                Support
              </Link>
            </nav>
            <div className="text-sm text-gray-500">
              {currentPage}
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-100 border-t mt-16">
      <div className="max-w-4xl mx-auto px-6 py-6">
        <div className="text-center text-gray-600">
          <p>&copy; {new Date().getFullYear()} BuyNothings. All rights reserved.</p>
          <p className="text-sm mt-2">Last updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</p>
        </div>
      </div>
    </footer>
  );
};

const App: React.FC = () => {
  return (
    <Router>
      <div className="min-h-screen bg-gray-50">
        <Header />
        <Routes>
          <Route path="/" element={<PrivacyPolicy />} />
          <Route path="/support" element={<Support />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
};

export default App;